/* eslint-disable no-magic-numbers */
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewEncapsulation
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { Subscription } from 'rxjs';

import { DraggableComponentPlaceholderInterface } from '@cactussoft/services/services-board/create-service/draggable-components.interface';
import { isNullOrUndefined } from '@shared/tools/is-undefined-null';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MultiLanguageDialogComponent } from '@shared/components/multi-language-dialog/multi-language-dialog.component';
import { FormValidationService } from '@shared/services/update-validity/update-validity.service';

@Component({
	selector: 'cactussoft-picker-builder',
	templateUrl: './picker-builder.component.html',
	styleUrls: ['./picker-builder.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PickerBuilderComponent implements OnInit {
	@Input() public iconName: string;
	@Input() public placeholder: DraggableComponentPlaceholderInterface;
	@Input() public initialValues: any;

	@Output() public removeComponentSource: EventEmitter<object> = new EventEmitter<object>();
	@Output() public changeValuesSource: EventEmitter<any> = new EventEmitter<any>();

	public formGroup: UntypedFormGroup;

	private formSubscription: Subscription;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private matDialog: MatDialog,
		private cdr: ChangeDetectorRef,
		private updateValidationService: FormValidationService
	) {}

	public ngOnInit(): void {
		isNullOrUndefined(this.initialValues) ? this.createDefaultForm() : this.createFormWithValues();
		this.formSubscription = this.formGroup.valueChanges.subscribe((value: any) => {
			this.changeValuesSource.emit(value);
		});
		this.updateValidationService.checkValidation$.subscribe(() => {
			this.updateValidationService.validateAllFormFields(this.formGroup);
			this.cdr.detectChanges();
		});
	}

	public removeComponent(): void {
		this.removeComponentSource.emit({});
	}

	public openMultiLanguageDialog(inputFormGroup: any, type: string, placeholder: string): void {
		const dialogRef: MatDialogRef<MultiLanguageDialogComponent> = this.matDialog.open(MultiLanguageDialogComponent, {
			data: { value: inputFormGroup.value, type: type, placeholder: placeholder },
			width: '800px',
			height: 'auto'
		});
		dialogRef.componentInstance.dialogSource.subscribe((data: any) => {
			inputFormGroup.setValue(data);
			inputFormGroup.markAllAsTouched();
			dialogRef.close();
		});
	}

	private createDefaultForm(): void {
		this.formGroup = this.formBuilder.group({
			id: new UntypedFormControl(null),
			titles: this.formBuilder.group({
				English: new UntypedFormControl(null, [Validators.required, Validators.maxLength(401)]),
				French: new UntypedFormControl(null, Validators.maxLength(401)),
				Dutch: new UntypedFormControl(null, Validators.maxLength(401)),
				German: new UntypedFormControl(null, Validators.maxLength(401))
			}),
			isMandatory: new UntypedFormControl(false)
		});
		// TODO: Set empty arrays for editing template (compose template object)
		this.changeValuesSource.emit(this.formGroup.value);
	}

	private createFormWithValues(): void {
		this.formGroup = this.formBuilder.group({
			id: new UntypedFormControl(this.initialValues.id),
			titles: this.formBuilder.group({
				English: new UntypedFormControl(this.initialValues.titles.English, [Validators.required, Validators.maxLength(401)]),
				French: new UntypedFormControl(this.initialValues.titles.French, Validators.maxLength(401)),
				Dutch: new UntypedFormControl(this.initialValues.titles.Dutch, Validators.maxLength(401)),
				German: new UntypedFormControl(this.initialValues.titles.German, Validators.maxLength(401))
			}),
			title: new UntypedFormControl(this.initialValues.title, Validators.maxLength(401)),
			isMandatory: new UntypedFormControl(this.initialValues.isMandatory)
		});
	}

	get titlesFormGroup(): any {
		return this.formGroup.controls.titles as UntypedFormGroup;
	}
}
